import { AppBar, Box, Button, Container, IconButton, Stack, Toolbar, Typography, Drawer, List, ListItem, ListItemButton, ListItemText, useMediaQuery, useTheme } from '@mui/material';
import { Menu as MenuIcon, Login } from '@mui/icons-material';
import { Link as RouterLink, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Logo from '../shared/Logo';
import { SCHOOL } from '../shared/constants';

const links = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/alumni', label: 'Alumni & Posts' },
  { to: '/result-check', label: 'Check Result' },
];

export default function PublicLayout() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppBar position="sticky" sx={{ bgcolor: '#fff', borderBottom: '1px solid #E2E8F0' }}>
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={{ gap: 2 }}>
            <RouterLink to="/" style={{ textDecoration: 'none' }}>
              <Logo />
            </RouterLink>
            <Box sx={{ flexGrow: 1 }} />
            {!isMobile && (
              <Stack direction="row" spacing={1}>
                {links.map((l) => (
                  <Button
                    key={l.to} component={NavLink} to={l.to}
                    sx={{
                      color: 'text.primary', fontWeight: 600,
                      '&.active': { color: 'primary.main', bgcolor: 'rgba(30,58,138,0.06)' },
                    }}
                  >
                    {l.label}
                  </Button>
                ))}
              </Stack>
            )}
            <Button
              variant="contained" color="primary" startIcon={<Login />}
              onClick={() => navigate('/login')}
              sx={{ ml: 1 }}
            >
              Portal Login
            </Button>
            {isMobile && (
              <IconButton onClick={() => setOpen(true)} edge="end" sx={{ ml: 1 }}>
                <MenuIcon />
              </IconButton>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box sx={{ width: 260, p: 2 }}>
          <Logo />
          <List sx={{ mt: 2 }}>
            {links.map((l) => (
              <ListItem key={l.to} disablePadding>
                <ListItemButton component={NavLink} to={l.to} onClick={() => setOpen(false)}>
                  <ListItemText primary={l.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>

      <Box component="footer" sx={{ bgcolor: 'primary.dark', color: '#fff', mt: 8, py: 5 }}>
        <Container maxWidth="lg">
          <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} justifyContent="space-between">
            <Box>
              <Logo variant="inverse" />
              <Typography variant="body2" sx={{ mt: 1.5, opacity: 0.85, maxWidth: 360 }}>
                {SCHOOL.tagline}. Established {SCHOOL.established}. Nurturing curious minds and confident leaders.
              </Typography>
            </Box>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>CONTACT</Typography>
              <Typography variant="body2">{SCHOOL.address}</Typography>
              <Typography variant="body2">{SCHOOL.phone}</Typography>
              <Typography variant="body2">{SCHOOL.email}</Typography>
            </Stack>
            <Stack spacing={0.5}>
              <Typography variant="subtitle2" sx={{ opacity: 0.7 }}>QUICK LINKS</Typography>
              {links.map((l) => (
                <RouterLink key={l.to} to={l.to} style={{ color: '#fff', textDecoration: 'none', opacity: 0.85 }}>
                  {l.label}
                </RouterLink>
              ))}
            </Stack>
          </Stack>
          <Typography variant="caption" sx={{ display: 'block', mt: 4, opacity: 0.6 }}>
            © {new Date().getFullYear()} {SCHOOL.name}. All rights reserved.
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}
